import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { EntityReferenceBasic } from '@/shared/types';

import type { TagCategoryItem } from '@/entities/tags/domain';

type CreateClassificationRequest = {
  name: string;
  displayName?: string;
  description?: string;
  provider?: 'system' | 'user';
  mutuallyExclusive?: boolean;
  domains?: string[];
  owners?: EntityReferenceBasic[];
};

export const createClassificationApi = async (request: CreateClassificationRequest): Promise<TagCategoryItem> => {
  const { data } = await openMetadataApiClient.post<TagCategoryItem>('/classifications', request);
  return data;
};

export type { CreateClassificationRequest };
